function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.123 504.123",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#84DBFF"
    },
    cx: 252.062,
    cy: 252.062,
    r: 252.062
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M136.271,409.6c-15.754,0-29.932-8.665-37.022-22.449c-7.089-13.785-5.908-30.326,3.151-42.929 l102.4-142.572V94.523h94.917v107.914l102.006,141.391c9.058,12.603,10.24,29.145,3.151,42.929 c-7.089,13.785-21.268,22.449-37.022,22.449H136.271V409.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF7058"
    },
    cx: 241.428,
    cy: 142.966,
    r: 11.028
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M387.545,354.068l-43.717-60.652H159.902l-43.323,60.652c-11.422,15.754,0,37.809,19.692,37.809 h231.582C387.545,392.271,398.966,369.822,387.545,354.068z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 184.32,
    cy: 338.708,
    r: 21.268
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 288.295,
    cy: 367.852,
    r: 12.209
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 321.772,
    cy: 322.56,
    r: 13.785
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7B64E"
    },
    cx: 246.942,
    cy: 242.215,
    r: 46.474
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCF66"
    },
    d: "M246.942,281.994c-22.055,0-40.172-18.117-40.172-40.172s18.117-40.172,40.172-40.172 s40.172,18.117,40.172,40.172S268.997,281.994,246.942,281.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B64E"
    },
    d: "M264.271,216.222l-2.363,11.028c-2.363-2.363-5.514-3.545-9.846-3.545 c-4.332,0-7.877,1.575-10.634,4.726c-1.575,1.575-2.757,3.938-3.151,6.695h21.662l-1.182,6.302h-21.268c0,0.788,0,1.575,0,2.363 c0,0.788,0,1.969,0,2.757h20.086l-1.182,6.302h-18.117c0.788,2.757,1.575,5.12,3.151,6.695c2.757,3.151,6.302,4.726,10.24,4.726 c5.12,0,9.058-1.575,12.209-4.726v12.209c-3.545,1.575-7.483,2.757-12.209,2.757c-7.877,0-14.178-2.757-19.298-7.877 c-3.545-3.545-5.514-8.271-6.695-13.391h-5.908l1.182-6.302h3.938c0-0.788,0-1.182,0-1.969c0-1.182,0-2.363,0-3.151h-5.12 l1.182-6.302h4.726c1.182-5.12,3.151-9.846,6.695-13.391c5.12-5.514,11.422-7.877,19.692-7.877 C257.182,213.858,260.726,214.646,264.271,216.222z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.348,
    y: 72.468,
    style: {
      fill: "#EDEDED"
    },
    width: 112.246,
    height: 22.055
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.728c99bd74761fd763ae999507fba7ac.svg";
export { ForwardRef as ReactComponent };